import { z } from 'zod';
import type { ProjectFilterCounts, ProjectFilterOption } from '@projectSearch/projectFilter';

const count = z.number().int().nonnegative();
const countsByBucket = z.record(z.string(), count);

/** Ответ GET /projects/filter-counts: числа вкладок с фильтром и без него (ключи — вкладки или области поиска). */
export const projectFilterCountsSchema: z.ZodType<ProjectFilterCounts> = z.object({
  filtered: countsByBucket,
  total: countsByBucket,
});

const projectFilterOptionSchema: z.ZodType<ProjectFilterOption> = z.object({
  id: z.string(),
  label: z.string(),
  group: z.enum(['department', 'edition', 'editor']).optional(),
  count,
});

/** Ответ GET /projects/filter-options: варианты подменю поля. */
export const projectFilterOptionsSchema = z.object({ items: z.array(projectFilterOptionSchema) });
